import Logo from "./Logo"
import { ArrowRight } from 'lucide-react'
import { Page } from './App';

export default function About({setPage}: {setPage: Function}) {
  return (
    <div className="flex flex-col text-center items-center">
      <Logo content="about todo me in"/>

      <p>Todo me in is a todo list app that means business.</p>
      <p>Complete your tasks or your friends will get an embarrasing email.</p>

      <Logo content="" subtext="built by:"/>
      <ul>
        <li><a href="https://www.linkedin.com/in/davidson-poole/">Davidson Poole <ArrowRight size={14} className="inline" /></a></li>
        <li><a href="https://emmettmcdow.com">Emmett McDow <ArrowRight size={14} className="inline"/></a></li>
      </ul>
      <button onClick={() => {setPage(Page.Home)}}
              className="bg-blue-500 text-white p-2 m-6 rounded flex items-center justify-center gap-2 hover:bg-blue-600 w-fit"
      >Back</button>
    </div>
  )
}
